import { useEffect, useState } from "react";
import ContainerBox from "../components/container";
import FormBuilder from "../formBuilder/formBuilder";
import { useAxios } from "../../utils/useAxios";
import DataTable from "../dataTable/dataTable";
import LoadOrdersDetailsId from "../../pages/Master/LoadOrders_details_id";
import { Button } from "@mui/material";
import { PlusIcon } from "../../icons";
import { Modal } from "../../components/ui/modal";
import MuiTabsForm from "../components/Mui/Tabs";
import DataTableTabs from "../dataTable/dataTableTabs";
import { useModal } from "../../hooks/useModal";
import FormBuildTabs from "../formBuilder/FormBuildTabs";
import MuiModelBox from "../../components/Mui/model/MuiModelBox";
import styled from "styled-components";
import FormLoading from "../../Loaders/formLoading";

interface props {
  formId: string;
  formIntData?: any;
}
const FormGenerator = ({ formId, formIntData }: props) => {
  const [showList, setShowList] = useState(true);
  const [dataHide, setDataHide] = useState(true);
  const [crudOp, setCrudOP] = useState({});
  const { isOpen, openModal, closeModal } = useModal();
  const { res, mutate, isPending, error } = useAxios({
    url: "/api/auth/form",
  });
  const {
    res: editRes,
    mutate: editMatate,
    isPending: editIsPending,
    error: editError,
  } = useAxios({
    url: "/api/auth/geteditdata",
  });

  useEffect(() => {
    if (formId) {
      mutate({ formId });
    }
  }, [formId]);

  const handleSplite = () => {
    setDataHide(true);
    showList ? setShowList(false) : setShowList(true);
  };

  const getEdit = (id: any, target: string) => {
    setDataHide(false);
    setShowList(false);
    editMatate({
      editId: id,
      formId: formId,
      target: target,
    });
  };

  useEffect(() => {
    if (editRes?.data?.dataDelete) {
      mutate({ formId });
      setShowList(true);
    }
  }, [editRes?.data?.dataDelete]);

  const listShow = (e: boolean) => {
    e && setShowList(true);
  };

  const crud = (event: any) => {
    openModal();
    setCrudOP(event);
  };

  const openlist = () => {};

  if (isPending) {
    return <div>Loading</div>;
  }

  return (
    <>
      {formIntData?.detailsPageId ? (
        <ContainerBox
          title={res?.data?.data?.title + " Details"}
          actions={
            <button
              onClick={handleSplite}
              className={`${showList ? "bg-indigo-500" : "bg-amber-500"}  text-white rounded py-1 p-3`}
            >
              {showList ? "Add" : "Show List"}
            </button>
          }
        >
          <LoadOrdersDetailsId formId={formId} formIntData={formIntData} />
        </ContainerBox>
      ) : (
        <>
          {/* <ContainerBox
            title={res?.data?.data?.title}
            actions={
              <button
                onClick={handleSplite}
                className={`${showList ? "bg-indigo-500" : "bg-amber-500"}  text-white rounded py-1 p-3`}
              >
                {showList ? "Add" : "Show List"}
              </button>
            }
          > */}

          {/* TOD0: need to config form database shobhit */}
          <div>
            {showList ? (
              <>
                {/* <DataTableTabs
                  formId={formId}
                  source={source}
                  crud={crud}
                  addbtn={
                    <Button
                      variant="contained"
                      sx={{
                        boxShadow: "none",
                        background: "#000",
                        color: "#fff!important",
                      }}
                      onClick={() => {
                        console.log("dileep kumar");
                        setChangeSplite(true);
                      }}
                      size="small"
                      startIcon={<PlusIcon width={16} height={16} />}
                    >
                      Add {title}
                    </Button>
                  }
                /> */}
                <DataTable
                  getEdit={getEdit}
                  formId={formId}
                  formIntData={formIntData}
                  addButton={
                    <>
                      {![
                        "carrier",
                        "trailer",
                        "vehicle",
                        "drivers",
                        "load",
                      ].includes(formId) && (
                        <Button
                          onClick={handleSplite}
                          startIcon={<PlusIcon width={16} height={16} />}
                        >
                          ADD NEW
                        </Button>
                      )}
                    </>
                  }
                />
              </>
            ) : (
              <>
                <FormBuilder
                  getformData={res?.data?.data}
                  editdata={dataHide ? {} : editRes?.data?.data}
                  listShow={listShow}
                />
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default FormGenerator;
const Div = styled("div")`
  .inpop {
    width: 100% !important;
  }
`;
